import React, { useCallback, useContext, useEffect, useState } from 'react';
import { SyncOutlined, ReloadOutlined } from '@ant-design/icons';
import { Button, PageHeader, Table, Layout } from 'antd';
import { apiClient, apiErrorMessage, hasPermission } from '../../../utils';
import { UserContext } from '../../contexts';
import { Section } from '../../../models/index';

const { Content } = Layout;

export function SectionsPage() {
  const { user } = useContext(UserContext);
  const [sections, setSections] = useState<Section[]>();
  const [canEdit, setCanEdit] = useState(false);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setCanEdit(hasPermission(user, 'productionSites.sync_sap'));
  }, [user]);

  const loadSections = useCallback(() => {
    setLoading(true);
    apiClient
      .get(`production-sites/sections`)
      .then((response: any) => {
        const responseSections: Section[] = response.data;
        const responseData = responseSections.map(section => {
          return {
            key: section.id,
            ...section,
          };
        });
        setSections(responseData);
        setLoading(false);
      })
      .catch((reason: any) => {
        setLoading(false);
        apiErrorMessage(reason);
      });
  }, []);

  useEffect(() => {
    loadSections();
  }, [loadSections]);

  const onRefreshClick = () => {
    loadSections();
  };

  const onSyncClick = () => {};

  const tableColumns: any[] = [
    {
      title: 'Kısım no',
      dataIndex: 'code',
      key: 'code',
    },
    {
      title: 'İsim',
      dataIndex: 'name',
      key: 'name',
    },
  ];

  return (
    <>
      <PageHeader
        extra={[
          <Button key="refresh" onClick={onRefreshClick} icon={<ReloadOutlined />}>
            Yenile
          </Button>,
          <>
            {canEdit && (
              <Button type="primary" key="sync" onClick={onSyncClick} icon={<SyncOutlined />}>
                SAP ile eşle
              </Button>
            )}
          </>,
        ]}
      />
      <Content>
        <Table columns={tableColumns} dataSource={sections} loading={loading} pagination={false} />
      </Content>
    </>
  );
}
